const DOI_MATCH = /((https?:)?\/\/([^/]+\/))?\b(10.\d{4,9}\/[-._;()/:A-Z0-9]+)\b/i;
const DOI_MATCH_INDEX = 4;

type DOINotFoundResult = [string];
type DOIFoundResult = [string, string, string];

// split DOI-like strings, optionally prefixed by root-level domain link (which
// will be stripped), from a string. note, this will only match a single
// DOI-like string. returns an array of 1 or 3 strings, the DOI being the second
// element if found
export function splitOnDOI(text: string): DOINotFoundResult | DOIFoundResult {
  const match = DOI_MATCH.exec(text);

  if (match) {
    return [
      text.slice(0, match.index),
      match[DOI_MATCH_INDEX],
      text.slice(match.index + match[0].length),
    ];
  }

  return [text];
}
